import { LogLevel } from '@/utils/logger'

// Environment configuration
export const config = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:5050',
  appName: import.meta.env.VITE_APP_NAME || 'Nexo',
  appVersion: import.meta.env.VITE_APP_VERSION || 'dev',
  buildSha: import.meta.env.VITE_BUILD_SHA || '',
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
  
  // Logging configuration
  logging: {
    level: import.meta.env.DEV ? LogLevel.DEBUG : LogLevel.WARN,
    enableConsole: true,
    enableRemote: import.meta.env.VITE_ENABLE_REMOTE_LOGGING === 'true',
    remoteEndpoint: import.meta.env.VITE_LOG_ENDPOINT,
    modules: {
      // Module-specific log levels
      AUTH: import.meta.env.DEV ? LogLevel.DEBUG : LogLevel.WARN,
      API: import.meta.env.DEV ? LogLevel.INFO : LogLevel.ERROR,
      UI: import.meta.env.DEV ? LogLevel.WARN : LogLevel.ERROR,
      OFFLINE: LogLevel.INFO,
    }
  }
}
